import axios from "axios";
import React, { useEffect, useState } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { client } from "../../auth/Client";
import envo from "../../environments/environmentProd";
import h, { getLoginData } from "../../helpers/helpers";
import { list } from "./menuList";
import { list2 } from "./menuList2";
import { list3 } from "./menuList3";
import { list4 } from "./menuList4";
import { list5 } from "./menuList5";
import { list8 } from "./menuList8";
import { list9 } from "./menuList9";
import {barinList} from './brainXMenuList'
import * as bootstrap from 'bootstrap';

import { connect } from "react-redux";
import { Route } from "react-router-dom";
import "./SideNav.scss";
import SideNavDisplay from "./SideNav.styled";
import { propTypes } from "react-image";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { actionList } from "./actionMenu";
import { list10 } from "./menuList10";

const apiUrl = envo.apiUrl;

function SideNav({ open, toggleSidenav, gamesCo }) {
  const {pathname} = useLocation();
  const history = useHistory();

  const [userInfo, setUserInfo] = useState({});
  const [isLogged, setIsLogged] = useState(false);
  const [gamesCount, setGamesCount] = useState(0);
  //const [RoutLink, setRoutLink] = useState("/login");
  //const [test, settest] = useState("");

  const [userPhoto, setUserPhoto] = useState("");
  const [userName, setUserName] = useState("");
  const location = useLocation()
  

  /* set lists on different portals */
  var url = window.location.href;
  var urlKsa = window.location.href.includes("ksa");
  var urlEgy = window.location.href.includes("egypt");
  var urlEthio = window.location.href.includes("ethio");
  var urlGamezone = window.location.href.includes("ao.playit");
  var urlGamezonekorek = window.location.href.includes("gamezones");
  var urlGamezworld = window.location.href.includes("gamezworld") ;
  var urlcompetition = window.location.hostname.includes("competition");

  var urlmtnng = window.location.hostname.includes("mtnng");
  var urlksa = window.location.hostname.includes("ksa");
  var urlgamezroid = window.location.hostname.includes("gamezroid");
  var urlramdan = window.location.hostname.includes("ramdank");
  var globalurl = window.location.hostname;
  var urlAfricell = window.location.hostname.includes("africell");
  var urlGamezonline = window.location.hostname.includes("gamezonline");
  var urldzo = window.location.hostname.includes("dzo.playit");
  var newgamezroid =
    urlgamezroid &&
    !globalurl.includes("asiacell") &&
    !globalurl.includes("jawwal") &&
    !globalurl.includes("zainiq") &&
    !globalurl.includes("ramdank");

  //  var newgamezroid = window.location.href.includes("local");

  var myList;
  var routerSignup = location.pathname.includes("brain-games")
    ? "/brain-games/signup"
    : location.pathname.includes("action-games")
    ? "/action-games/signup"
    : "/signup";
  var routerLink = location.pathname.includes('brain-games') ? "/brain-games/login" : location.pathname.includes('action-games') ? "/action-games/login" :"/login";

  // console.log(location, globalurl);

  if (urlksa) {
    routerSignup = "/signupksa";
  } else if (
    urlgamezroid &&
    !globalurl.includes("asiacell") &&
    !globalurl.includes("jawwal") &&
    !globalurl.includes("zainiq") &&
    !globalurl.includes("ramdank")
  ) {
    routerSignup = "/signup11";
    // routerSignup ="/Ramdanksignup"
  } else if (globalurl.includes("ramdank")) {
    routerSignup = "/Ramdanksignup";
  } else {
    routerSignup = location.pathname.includes("brain-games")
      ? "/brain-games/signup"
      : location.pathname.includes("action-games")
      ? "/action-games/signup"
      : "/signup";
  }

  if (urlcompetition) {
    routerLink = "/signup";
  }
  if (url.includes("zain-iq")) {
    myList = [...list2];
  }
  if (url.includes("jawwal")) {
    myList = [...list];
  } else if (globalurl.includes("asiacell")) {
    myList = [...list9];
  } else if (urlKsa || urlEgy) {
    myList = [...list3];
  } else if (urlEthio) {
    myList = [...list4];
  } else if (urlGamezone) {
    myList = [...list5];
  }
  // else if (newgamezroid)  { myList = [...list8] }
  else if (urlmtnng) {
    checkAuth();
    myList = [...list];
  } else if (location.pathname.includes("brain-games")) {
    myList = [...barinList];
  } else if (location.pathname.includes("action-games")) {
    myList = [...actionList];
  } else if (urlGamezworld) {
    myList = [...list10];
  }
   else {
    myList = [...list];
  }

  // if (urlmtnng) {
  //   checkAuth();
  //   myList = [...list]
  // }

  const [availableLinks, setAvailableLinks] = useState(myList);
  useEffect(() => {
    checkAuth();
  }, []);
const [unsubscribePath, setUnsubscribePath] = useState("/unsubscribe");
const [unsubscribeLabel, setUnsubscribeLabel] = useState("unsubscribe");
const [can_cancel, setCanCancel] = useState(false);

  function notCompletedProfile() {
    const data = getLoginData();
    if (!data.email || !data.userName || !data.userPhoto) {
      return true;
    }
    return false;
  }

  async function checkAuth() {
   //console.log("checkAuth");
    const authorized = await client.auth();
   //console.log("auth", authorized);
    if (authorized) {
      const data = getLoginData();
     //console.log("user info", data);
      setUserName(data.userName);
      setUserPhoto(data.userPhoto);
      const count2 = await getGamesCount();
      setGamesCount(count2);
      return setIsLogged(true);
    }
    setUserName("");
    setUserPhoto("");
    return setIsLogged(false);
  }

  // async function checkAuth() {
  //  //console.log('checkAuth')
  //   const authorized = await client.auth();
  //   if (authorized) {
  //     setUserInfo(getLoginData());
  //     const count2 = await getGamesCount();
  //     setGamesCount(count2);
  //     return setIsLogged(true);
  //   }
  //   setUserInfo({});
  //   return setIsLogged(false);
  // }

  async function getGamesCount() {
    const options = {
      headers: { AUTHORIZATION: `Bearer ${localStorage.getItem("token")}` },
    };
    const res = await axios.get(`${apiUrl}/playit/stats`, options);
    if (!res.data) return 0;

    return res.data.data.myGamesCount;
  }

useEffect(() => {
  const isLibya =
    window.location.hostname.includes("libya") 

  if (isLogged && isLibya) {
    const token = localStorage.getItem("token");
    const msisdn = localStorage.getItem("phoneNum");

    if (!msisdn) {
      console.warn("No MSISDN found in userProfile");
    } else {
      axios
        .get(
          `https://apissl.playit.mobi/api/v2/connex-libya/get-sub-details?msisdn=${msisdn}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          const canCancel = res.data.data.can_cancel ;
          setCanCancel(canCancel);
          console.log("Libya subscription check response:", res.data.data.can_cancel);
          console.log("canCancel", canCancel);
          //setUnsubscribePath(canCancel ? "/unsubscribe" : routerSignup);
          setUnsubscribeLabel(canCancel ? "unsubscribe" : "subscribe");

          const updatedList = myList.map((item) => {
            if (item.text === "unsubscribe") {
              return {
                ...item,
                //url: canCancel ? "/unsubscribe" : handleSubscriptionClick(),
                text: canCancel ? "unsubscribe" : "subscribe",
              };
            }
            return item;
          });
          console.log("updatedList", updatedList);
          setAvailableLinks(updatedList);
        })
        .catch((err) => {
          console.error("Libya check failed", err);
          setAvailableLinks(myList);
        });

      return;
    }
  }

  if (urldzo) {
    const dzoUnsubscribeItem = {
      url: "/separatedunsub",
      text: "unsubscribe",
    };
    const baseList = isLogged
      ? myList.filter((item) => item.text !== "unsubscribe")
      : myList.filter((i) => !i.logged);
    setAvailableLinks([...baseList, dzoUnsubscribeItem]);
    return;
  }

  if (isLogged) {
    setCanCancel(true);
    const updatedList = myList.map((item) => {
      if (item.text === "unsubscribe") {
        return {
          ...item,
          url: unsubscribePath,
          text: unsubscribeLabel,
        };
      }
      return item;
    });

    setAvailableLinks(updatedList);
  } else {
    const filteredList = myList.filter((i) => !i.logged);
    const langItemIndex = filteredList.findIndex(
      (res) => res.url === "/change-language"
    );

    if (urlAfricell && langItemIndex !== -1) {
      filteredList.splice(langItemIndex, 1);
    }

    setAvailableLinks(filteredList);
  }
}, [isLogged, routerSignup]);


  const closeNav = () => {
    toggleSidenav();
  };
  const changeActiveCat = () =>{
    let active_main = JSON.parse(localStorage.getItem('activeLocally')).main
    let active_sub = JSON.parse(localStorage.getItem('activeLocally')).main
    let active_category = JSON.parse(localStorage.getItem('activeLocally')).main
    // location 

    toggleSidenav();
    if(pathname=="/"){
      const obj = {
        main: active_main,
        sub: active_sub,
        category: "",
      };
      localStorage.setItem("activeLocally", JSON.stringify(obj));
  
      window.location.reload();
    }else{
      history.push("/");
    }

  };


  const listSection = availableLinks.map((i, k) => {
    if (i.text === "my_games") {
      //console.log('not filtered list')
      return (
        <Link
          to={i.url}
          className="listItem"
          key={`cmenuItem-${k}`}
          onClick={() => closeNav()}
        >
          <Trans>{i.text}</Trans>
          <div className="count">{gamesCo + gamesCount}</div>
        </Link>
      );
    }
    if (i.text === "side_nav.profile" && notCompletedProfile()) {
      return (
        <Link
          to={i.url}
          className="listItem notCompleted"
          key={`bmenuItem-${k}`}
          onClick={() => closeNav()}
        >
          <Trans>{i.text}</Trans>
          <div className="ellipse"></div>
        </Link>
      );
    }

    if (i.text === "Home") {
      return (
        <Link
          to={i.url}
          className="listItem home"
          key={`bmenuItem-${k}`}
          onClick={() => changeActiveCat()}
        >
          <Trans>{i.text}</Trans>
        </Link>
      );
    }
  
if ((i.text === "subscribe" || i.text === "unsubscribe") && !urldzo) {
  return (
    <a
       
      className="listItem"
      key={`unsubscribe-${k}`}
      onClick={(e) => {
        e.preventDefault();
        handleSubscriptionClick();
      }}
    >
      <Trans>{can_cancel ? 'unsubscribe' :'subscribe'}</Trans>
    </a>
  );
}

    return (
      <Link
        to={i.url}
        className="listItem"
        key={`amenuItem-${k}`}
        onClick={() => closeNav()}
      >
        <Trans>{i.text}</Trans>
      </Link>
    );
  });
  ////console.log('listSection',listSection);
  //   const Refresh = ({ path = '/' }) => (
  //     <Route
  //         path={path}
  //         component={({ history, location, match }) => {
  //             history.replace({
  //                 ...location,
  //                 pathname:location.pathname.substring(match.path.length)
  //             });
  //             return null;
  //         }}
  //     />
  // );
 const handleSubscriptionClick = () => {
  
  if (can_cancel) {
    // Existing cancel behavior
    window.location.href =
      window.location.pathname.includes("brain-games")
        ? "/brain-games/unsubscribe"
        : window.location.pathname.includes("action-games")
        ? "/action-games/unsubscribe"
        : "/unsubscribe";
  } else {

    console.log("Subscription is not active or cannot be canceled.");

const myModal = new bootstrap.Modal(
  document.getElementById('confirmSubscribeModal'),
  { backdrop: false }
);    
myModal.show();

    const sureBtn = document.getElementById("confirmSubscribeBtn");
    sureBtn.onclick = async () => {
        axios.post(`https://apissl.playit.mobi/api/v2/connex-libya/send-otp-activate`, {msisdn: JSON.parse(localStorage.getItem("phoneNum"))})
        .then(res => {
          if (res.data.status === true) {
            window.location.href = "/verify-otp-activate";
           console.log("res",res)
           console.log("OTP sent successfully, redirecting to verify-otp page");
          }
         
        })
        .catch(function (error) {
          console.error("Error sending OTP for subscription:", error);
        })
        .finally(function () {
        });
        
    
      }
    }
};
  return (
    <SideNavDisplay
      id="sideNav"
      open={open}
      isRTL={h.isRTL()}
      profileImg={userPhoto}
    >
      {/* <Refresh path="/refresh"/> */}
      <div className="side">
        <div className="close" onClick={() => closeNav()}>
          &times;
        </div>
        <div className="header">
          <div className="img">
            <div className="avatar" />
          </div>
          {isLogged ? (
            <div className="info">
              {false /*nocompleted*/ ? (
                <div>
                  <Trans>Hi There!</Trans>
                </div>
              ) : (
                <>
                  <div>{userName}</div>
                  <div>{localStorage.getItem("email")}</div>
                </>
              )}
            </div>
          ) : (
            // Anonymous
            <div className="info">
              <div>
                <Trans>Hi There!</Trans>
              </div>
              <div className="links">
                <Link to={routerLink}>
                  <Trans>sign_in</Trans>
                </Link>
                <Link to={routerSignup}>
                  <Trans>sign_up</Trans>
                </Link>
              </div>
            </div>
          )}
        </div>
        <div className={urlramdan ? "list listcom" : "list"}>
  {listSection}

  {urlGamezonline ? (
    <a className="listItem" href="./games-online-policy">
      <Trans>Privacy_Policy</Trans>
    </a>
  ) : urlGamezworld || urlGamezone ? (
    <a className="listItem" href="./privacypolicy">
      <Trans>Privacy_Policy</Trans>
    </a>
  ) : urlGamezonekorek ? (
    <a className="listItem" href="http://gamezones.mobi/gamezones-privacypolicy.html">
      <Trans>Privacy_Policy</Trans>
    </a>
  ) : (
    <a className="listItem" href="http://playit.mobi/ar_privacypolicy.html">
      <Trans>Privacy_Policy</Trans>
    </a>
  )}
</div>

      </div>
      <p>test</p>

      <div className="rest" onClick={() => closeNav()} />
        <div
          class="modal fade"
          id="confirmSubscribeModal"
          tabindex="-1"
          aria-labelledby="confirmSubscribeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body text-center text-black">
               <Trans>Are you sure you want to subscribe again?</Trans>
              </div>
              <div class="modal-footer justify-content-center">
                <button type="button" style={{background:'red'}} class="btn btn-danger" data-bs-dismiss="modal"><Trans>Cancel</Trans></button>
                <button type="button" class="btn btn-primary" id="confirmSubscribeBtn"><Trans>Sure</Trans></button>
              </div>
            </div>
          </div>
        </div>
    </SideNavDisplay>
  );
}

/* Start Update State Use REDUX */
function mapStateToProps(state) {
  return { gamesCo: state.count };
}

function mapDispatchToProps(dispatch) {
  return {
    increase: () => dispatch({ type: "INCREASE" }),
    decrease: () => dispatch({ type: "DECREASE" }),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SideNav));
